<template>
    <div class="box">
        <div class="box-body">
            <div class="form-fields-heavy">
                <div class="form-group">
                    <label for="contact_name">Name</label>
                    <input id="contact_name"
                           v-model="contactDetails.name"
                           type="text"
                           class="form-control"
                           placeholder="Your name">
                </div>
                <div class="form-group">
                    <label for="contact_email">Sender's email</label>
                    <input id="contact_email"
                           v-model="contactDetails.email"
                           type="text"
                           class="form-control"
                           placeholder="email@address.com">
                </div>
                <div class="form-group">
                    <label for="contact_subject">Subject</label>
                    <input id="contact_subject"
                           v-model="contactDetails.subject"
                           type="text"
                           class="form-control"
                           placeholder="Subject">
                </div>
                <div> 
                    <label for="contact_query">Query</label>
                    <textarea id="contact_query"
                              v-model="contactDetails.query"
                              rows="10"
                              class="form-control"
                              placeholder="Your query..." />
                </div>
            </div>
        </div>
        <div class="box-footer">
            <div class="float-right">
                <button type="button"
                        class="btn btn-color btn-outline-primary wide"
                        @click="resetForm">
                    Reset Form
                </button>
                <button type="button"
                        class="btn btn-primary btn-sm btn-dark-color wide"
                        @click="sendQuery">
                    Send
                </button>
            </div>
        </div>
    </div>
    <simple-dialog ref="querySendResponse"
                   dialog-id="graph-modal"
                   :icon="queryIcon"
                   title="Send Query"
                   :body="querySendMessage" />
</template>


<script>

    import axios from 'axios';
    import { axiosConfig, axiosError } from '../../js/AjaxUtilities.js'
    import simpleDialog from '../../components/SimpleDialog.vue';

    export default {
        name: 'ContactUsForm',
        components: {
            simpleDialog
        },
        data: () => {
            return {
                contactDetails: null,
                querySendMessage: '',
                querySuccess: false,

            }
        },
        computed: {
            queryIcon: function () {
                return (this.querySuccess) ? "icon-checkmark" : "icon-wrong";
            }
        },
        beforeMount: function () {
            this.initContactDetails();
        },
        mounted: function () {
            this.getCurrentUserEmail();
        },
        methods: {
            initContactDetails: function () {
                this.contactDetails = {
                    name: '',
                    email: '',
                    subject: '',
                    query: ''
                };
            },
            resetForm: function () {
                this.initContactDetails();
            },
            getCurrentUserEmail: function () {
                let that = this;
                axios
                    .get('/GetHelp/GetLoggedInUserEmail')
                    .then(function (response) {
                        if (response.data.success) {
                            that.contactDetails.email = response.data.email;
                        }
                    })
                    .catch(function (error) {
                        axiosError("Get logged in user email", axios, error);
                    });

            },
            sendQuery: function () {
                let that = this;
                let data = {
                    name: this.contactDetails.name,
                    email: this.contactDetails.email,
                    subject: this.contactDetails.subject,
                    query: this.contactDetails.query
                }
                axios
                    .post('/GetHelp/SendContactQuery', data, axiosConfig())
                    .then(function (response) {
                        that.querySendMessage = response.data.message;
                        if (response.data.success) {
                            that.initContactDetails();
                            that.querySuccess = true;
                        } else {
                            that.querySuccess = false;
                        }
                        that.$refs.querySendResponse.open();
                    })
                    .catch(function (error) {
                        axiosError("Send contact query", axios, error);
                    });

            }

        }
    }

</script>

<style>
</style>
